export enum LoaderSizeEnum {
	SMALL = '24px',
	LARGE = '40px',
}

export enum LoaderColorVariantEnum {
	DARK = 'dark',
	MEDIUM = 'medium',
	LIGHT = 'light',
	BLACK = 'black',
	WHITE = 'white',
	DISABLED = 'disabled',
}

export interface IPropRing {
	size: LoaderSizeEnum;
}

export interface IProps {
	size: LoaderSizeEnum;
	colorVariant: string;
}

export interface IRingPartProps {
	size: LoaderSizeEnum;
	colorVariant: string;
}
